/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Typography } from 'antd';

// Misc imports
const DeploymentChannel = (props) => {
  const { deploymentChannelTitle = '', deploymentChannelIcon, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <Typography.Text className="d-inline-flex align-items-center" {...restProps}>
      {
        deploymentChannelIcon ? (
          <span className="mr-2 fs-xl">
            {deploymentChannelIcon}
          </span>
        ) : null
      }

      <span>
        {t(deploymentChannelTitle, { context: 'deployment channel' })}
      </span>
    </Typography.Text>
  );
};

DeploymentChannel.propTypes = {
  deploymentChannelTitle: PropTypes.string,
  deploymentChannelIcon: PropTypes.object
};

export default DeploymentChannel;
